import { Link2, Smartphone, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      icon: <Link2 className="w-8 h-8" />,
      title: t('howItWorks.step1Title'),
      description: t('howItWorks.step1Description'),
      color: 'bg-lime-400',
    },
    {
      number: '02',
      icon: <Smartphone className="w-8 h-8" />,
      title: t('howItWorks.step2Title'),
      description: t('howItWorks.step2Description'),
      color: 'bg-lavender-400',
    },
    {
      number: '03',
      icon: <TrendingUp className="w-8 h-8" />,
      title: t('howItWorks.step3Title'),
      description: t('howItWorks.step3Description'),
      color: 'bg-dark-800',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gray-50 dark:bg-dark-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-dark-800 dark:text-white mb-6">
            {t('howItWorks.sectionTitle')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            {t('howItWorks.sectionSubtitle')}
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gray-200 dark:bg-dark-600 -translate-y-1/2" />

          <div className="grid lg:grid-cols-3 gap-12 lg:gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step card */}
                <div className="bg-white dark:bg-dark-700 rounded-3xl shadow-soft dark:shadow-none dark:border dark:border-dark-600 p-8 relative z-10 h-full">
                  {/* Number badge */}
                  <div className={`absolute -top-4 -left-4 w-12 h-12 ${step.color} rounded-2xl flex items-center justify-center ${step.color === 'bg-dark-800' ? 'text-white' : 'text-dark-800'} font-bold text-lg shadow-lg`}>
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className={`w-16 h-16 ${step.color} ${step.color === 'bg-dark-800' ? 'text-white' : 'text-dark-800'} rounded-2xl flex items-center justify-center mb-6 mt-4`}>
                    {step.icon}
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {step.description}
                  </p>
                </div>

                {/* Arrow for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-4 w-8 h-8 bg-lime-400 rounded-full -translate-y-1/2 z-20 items-center justify-center">
                    <svg className="w-4 h-4 text-dark-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
